import { AuthService } from './../../service/auth.service';
import { EcomicService } from './../../service/comics/ecomic.service';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { Episode } from '../../models';
import 'rxjs/add/operator/map';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
declare const $: any;

@Component({
  selector: 'app-e-comic-episode-add',
  templateUrl: './e-comic-episode-add.component.html',
  styleUrls: ['./e-comic-episode-add.component.css']
})
export class EComicEpisodeAddComponent implements OnInit {
  comicepisodeForm: FormGroup;
  loading: boolean = false;
  load: boolean = false;
  publish_date: any;
  series: any;
  seasons: any;
  id: any;
  user: any;
  publish: any;
  reads: any;
  // variables to hide and show the dropdown to refresh the data to set the exact value
  status: any = true;
  showseason: any = true;
  showseries: any = false;
  episodeno: any = true;
  selectedseason: any;

  thumbnail_image: File;
  cover_image: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;
  singleepisode: any;
  constructor(private form: FormBuilder, private router: Router, private auth: AuthService,
    private afs: AngularFirestore, private comicService: EcomicService, private route: ActivatedRoute,
    public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {

    this.comicepisodeForm = this.form.group({
      comic_series: ['', [Validators.required]],
      comic_seasons: ['', [Validators.required]],
      episode_title: ['', [Validators.required]],
      episode_no: ['Episode 1', [Validators.required]],
      select_quarter: ['1', [Validators.required]],
      thumbnail: ['', []],
      comic_image: ['', []],
      hits: ['', [Validators.required]],
      seo_url: ['', [Validators.required]],
      seo_title: ['', [Validators.required]],
      seo_description: ['', [Validators.required]],
      seo_keywords: ['', [Validators.required]],
      status: ['InActive', [Validators.required]],
      publish_date_and_timer: ['', []],
    });
    // getting the available eseries from the database
    this.comicService.getserious().then(eseriesdata => {
      // subscribing the data from the service
      eseriesdata.subscribe(eseries => {
        this.series = eseries;
        if (this.route.firstChild) {
          this.route.firstChild.params.subscribe(params => {
            this.id = params['id'];
            if (this.id) {
              this.status = false;
              this.showseries = false;
              this.showseason = false;
              this.episodeno = false;
              this.comicService.getsinglecomic(this.id, 'Ecomicepisode').then(episodedata => {
                episodedata.subscribe(singleepisode => {
                  this.singleepisode = singleepisode;
                  this.comicService.getseasons(singleepisode['comic_series']).then(eseasonsdata => {
                    // subscribing the data from the service
                    eseasonsdata.subscribe(eseasons => {
                      this.seasons = eseasons;
                      this.comicepisodeForm.get('comic_series').setValue(singleepisode['comic_series']);
                      this.comicepisodeForm.get('comic_seasons').setValue(singleepisode['comic_seasons']);
                      this.comicepisodeForm.get('episode_title').setValue(singleepisode['episode_title']);
                      this.comicepisodeForm.get('episode_no').setValue(singleepisode['episode_no']);
                      this.comicepisodeForm.get('thumbnail').setValue(singleepisode['thumbnail']);
                      this.comicepisodeForm.get('comic_image').setValue(singleepisode['comic_image']);
                      this.comicepisodeForm.get('hits').setValue(singleepisode['hits']);
                      this.comicepisodeForm.get('seo_url').setValue(singleepisode['seo_url']);
                      this.comicepisodeForm.get('seo_title').setValue(singleepisode['seo_title']);
                      this.comicepisodeForm.get('seo_description').setValue(singleepisode['seo_description']);
                      this.comicepisodeForm.get('seo_keywords').setValue(singleepisode['seo_keywords']);
                      this.comicepisodeForm.get('status').setValue(singleepisode['status']);
                      const date = singleepisode['publish_date_and_timer']?new Date(singleepisode['publish_date_and_timer'].seconds*1000):'';

                      // const publishdate = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
                      this.comicepisodeForm.get('publish_date_and_timer').setValue(date);
                      this.cover_image_url = singleepisode['cover_image'];
                      this.thumbnail_image_url = singleepisode['thumbnail_image'];
                      this.status = true;
                      this.showseries = true;
                      this.showseason = true;
                      this.episodeno = true;
                    });
                  });
                });
              });
            }
          });
        } else {
          this.getseasons(this.series[0].id);
          this.comicepisodeForm.get('comic_series').setValue(this.series[0].id);
          this.showseries = true;
          if (!this.id) {
            this.auth.getuser().then(userdetails => {
              this.user = userdetails;
            });
          }
        }
      });
    });
  } catch(error) {
    this.toastr.error('Somthing went wrong please try later!', 'Oops!');
    console.log(error);
  }

  async addepisode(value, valid) {
    if (valid) {
      await this.comicService.checkepisode(value.comic_seasons, value.episode_no).then(async episode => {
        if (episode) {
          if (!this.id) {
            this.toastr.error('The episode is already added!', 'Oops!');
            return true;
          } else if (value.episode_no != this.singleepisode.episode_no) {
            this.toastr.error('The episode is already added!', 'Oops!');
            return true;
          }
        }
        this.loading = true;
        const season: Episode = {
          comic_series: value.comic_series,
          comic_seasons: value.comic_seasons,
          episode_title: value.episode_title,
          episode_no: value.episode_no,
          episode_number: parseInt(value.episode_no.slice(8)),
          hits: value.hits,
          seo_url: value.seo_url,
          seo_title: value.seo_title,
          seo_description: value.seo_description,
          seo_keywords: value.seo_keywords,
          status: value.status,
          publish_date_and_timer: value.publish_date_and_timer? new Date(value.publish_date_and_timer):''
        };
        
        try {
          if (this.id) {
            let thumbnail;
            let coverimage;
            // Checking if the cover image is changed if changed the update the image in sapces and also db.
            if (this.cover_image) {
              coverimage = await this.auth.uploadimage('comic/cover/', this.cover_image, false);
              season.cover_image = coverimage['Location'];
            }
            // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
            if (this.thumbnail_image) {
              thumbnail = await this.auth.uploadimage('comic/thumbnail/', this.thumbnail_image, false);
              season.thumbnail_image = thumbnail['Location'];
            }

            const document = await this.afs.doc(`/Ecomicepisode/${this.id}`);
            const update = await document.update(season);
            this.toastr.success('Ecomic Episode Added!', 'Success!');

            this.router.navigate(['/comic-episode']);
          } else {
            // checks if the images is selected if not throws the error
            if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
            if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
            // uploading the images to the spaces and getting the uoloaded location
            const thumbnail = await this.auth.uploadimage('comic/thumbnail/', this.thumbnail_image, false);
            const coverimage = await this.auth.uploadimage('comic/cover/', this.cover_image, false);
            const updatereads = await this.afs.doc('Ecomicseason/' + value.comic_seasons).update({ reads: this.reads + parseInt(value.hits) })
            season.thumbnail_image = thumbnail['Location'];
            season.cover_image = coverimage['Location'];
            season.admin = this.user.uid;
            season.addedby = this.user.username;
            season.createdAt = new Date();
            season.date = new Date().toString();
            season.season_title = this.selectedseason.season_title;
            const eseasondata = await this.afs.collection('Ecomicepisode').add(season);
            const esid = eseasondata.id;
            const id = await this.afs.doc(`/Ecomicepisode/${esid}`).update({ id: esid });
            this.toastr.success('Ecomic Episode Added!', 'Success!');
            this.router.navigate(['/comic-episode']);
          }
        } catch (error) {
          console.log(error);
          this.loading = false;
          this.toastr.error('Somthing went wrong please try later!', 'Oops!');
          this.load = true;
        }
      })
    } else {
      console.log('error');
    }
  }
  async setseason(id) {
    console.log(id);

    const singleseason = await this.afs.doc('/Ecomicseason/' + id);
    const data = singleseason.valueChanges();
    data.subscribe(season => {
      this.selectedseason = season;
      this.reads = parseInt(season['reads']);
      console.log(this.selectedseason);
    });
    return true;
  }

  async getseasons(id) {
    this.showseason = false;
    try {
      await this.comicService.getseasons(id).then(eseasonsdata => {
        // subscribing the data from the service
        eseasonsdata.subscribe(eseasons => {
          this.seasons = eseasons;
          if (this.seasons.length >= 1) {
            this.comicepisodeForm.get('comic_seasons').setValue(eseasons[0]['id']);
            this.setseason(eseasons[0]['id']);
          }
          this.showseason = true;
        });
      });
    } catch (error) {
      this.showseason = true;
      this.toastr.error('Somthing went wrong please try later!', 'Oops!');
      console.log(error);
    }
  }

  changeListner1(event) {
    this.thumbnailimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.thumbnail_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner2(event) {
    this.coverimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/E-comics/e-comic-episode-add/e-comic-episode-add.component.ts